import styledComponents from 'styled-components';
import _ from 'lodash';

import React from 'react';
import { MAX_CONTENT_WIDTH } from './styleConstants';

const px = (value) => {
  if (!(value)) return 0;
  if (_.isNumber(value)) return `${value}px`;
  return value;
};

const Clamper = styledComponents.div`
  max-width: ${props => px(props.max) || MAX_CONTENT_WIDTH}
  height: 100%;
  `;

const ClamperOuter = styledComponents.div`
width: 100%;
height: 100%;
`;

export default ({ children }) => (
  <ClamperOuter data-type="clamper-outer"><Clamper data-type="clamper">{children}</Clamper></ClamperOuter>);
